<template>
  <div class="edit-article">
    <div class="center-block">
      <a-form-model 
      ref="form"
      :model="form" 
      :rules="rules"
      labelAlign="left" 
      :colon="false" 
      :label-col="{ span: 3 }" 
      :wrapper-col="{ span: 21 }">
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题"/>
        </a-form-model-item>
        <a-form-model-item label="部门" prop="department" v-if="!isArticle" :wrapper-col="{ span: 11 }">
          <a-input v-model="form.department"  placeholder="请输入部门"/>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="contact" v-if="!isArticle" :wrapper-col="{ span: 11 }">
          <a-input v-model="form.contact"  placeholder="请输入邮箱、电话或手机号码"/>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content">
          <editor ref="editor" v-model="form.content"></editor>
        </a-form-model-item>
        <a-form-model-item :label="isArticle?'列表配图':'图片'" class="custom-form-item">
          <upload-image ref="imgUpload" v-model="form.imgList" :maxNum="isArticle?1:10" :multi="!isArticle"></upload-image>
          <p class="tip-text" style="margin-top: -5px;">
            <a-icon type="info-circle" theme="filled" />
            图片建议尺寸为200*150
          </p>
        </a-form-model-item>
        <a-form-model-item label="附件">
          <upload-file ref="fileUpload" v-model="form.appendixList" :maxNum="10" style="width: 250px;"></upload-file>
          <p class="tip-text">
            <a-icon type="info-circle" theme="filled" />
            最多可上传10个文件，单个文件大小100M以内
          </p>
        </a-form-model-item>
        <a-form-model-item label="标签" required prop="tagIds" class="custom-form-item">
          <a-tag v-for="tag in form.tagIds" :key="tag.id" :closable="true" @close="() => removeTag(tag)">
            {{ tag.tagName }}
          </a-tag>
          <a-tag v-if="form.tagIds.length<5" style="borderStyle: dashed;cursor: pointer;background: none;" @click="showTags=true">
            <a-icon type="plus" /> 添加标签
          </a-tag>
          <p class="tip-text">
            <a-icon type="info-circle" theme="filled" />
            最多可添加5个标签
          </p>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 21, offset: 3 }">
          <div class="control-btns">
            <a-button type="primary" @click="onSubmit('PUBLISH')">
              发布
            </a-button>
            <a-button style="margin-left: 10px;" @click="onSubmit('DRAFT')">
              保存草稿
            </a-button>
            <span v-if="draftList.length>0" class="draft-box" @click="showDraftbox=true">
              <a-icon type="mail" />
              草稿箱({{draftList.length}})
            </span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <choose-tag v-model="showTags" :list="form.tagIds" @change="tagsUpdate"></choose-tag>
    <draft-box v-model="showDraftbox" :list="draftList" @change="updateContent" @delete="delDraft"></draft-box>
  </div>
</template>
<script>
import Editor from './components/Editor.vue'
import UploadFile from '@/components/UploadFile.vue'
import UploadImage from './components/UploadImage.vue'
import ChooseTag from './components/ChooseTag.vue'
import DraftBox from './components/DraftBox.vue'
import { isPhone, isEmail, isTel } from '@/utils/reg'
import { cloneDeep } from '@/utils'
import { saveArticle, getDraftList, getDetail, delDraft, logoutApi } from '@/utils/api'
import xss from 'xss'

// 提bug模板
const BUG_TEMPLATE = `<h2><span style="font-size: 12pt;"><strong><span style="color: #333333; font-family: 'Arial Normal', Arial, sans-serif;">问题描述:</span></strong></span></h2>\n<p>&nbsp;</p>\n<p><span style="font-size: 12pt;"><strong><span style="color: #333333; font-family: 'Arial Normal', Arial, sans-serif;">复现步骤:</span></strong></span></p>\n<p>&nbsp;</p>\n<p><span style="font-size: 12pt;"><strong><span style="color: #333333; font-family: 'Arial Normal', Arial, sans-serif;">操作环境、版本等信息</span><span style="color: #333333; font-family: 'Arial Normal', Arial, sans-serif;">:</span></strong></span></p>\n<p>&nbsp;</p>\n<p><span style="font-size: 12pt;"><strong><span style="color: #333333; font-family: 'Arial Normal', Arial, sans-serif;">预期结果:</span></strong></span></p>`
export default {
  components: { Editor, UploadFile, ChooseTag, DraftBox, UploadImage },
  data() {
    return {
      form: {
        id: '',
        title: '',
        content: '',
        category: 'ARTICLE', // ARTICLE:文章 BUG:提问
        contact: '',
        department: '',
        tagIds: [],
        imgList: [],
        appendixList: [],
      },
      showTags: false,
      showDraftbox: false,
      draftList: [],
      leaveActive: false, // 是否是主动跳转
    }
  },
  computed: {
    // 是否是新增
    isAdd(){
      return this.form.id === ''
    },
    // 是否是 文章
    isArticle() {
      return this.form.category === 'ARTICLE'
    },
    // 是否登录用户
    isLogin() {
      return !!this.$store.state.userInfo.uid
    },
    rules() {
      const list = {
        title: [
          {required: true, message: '请输入标题'},
          {max: 200, message: '最多200个字符'}
        ],
        department: [
          {required: true, message: '请输入部门'},
          {max: 50, message: '最多50个字符'}
        ],
        contact: [
          {required: true, message: '请输入联系方式'},
          {max: 50, message: '最多50个字符'},
          {  validator: (rule, value, callback) => {
              const isRight = isPhone(value) || isEmail(value) || isTel(value)
              isRight ? callback() : callback(new Error('请输入正确的邮箱、电话或手机号'))
            }
          }
        ],
        content: [{required: true, message: '请输入正文'}],
        tagIds: [{ 
          validator: (rule, value, callback) => {
            value.length ? callback() : callback(new Error('至少选择一个标签'))
          }
        }]
      }
      if(this.isArticle) {
        delete list.department
        delete list.contact
      }
      return list
    }
  },
  created() {
    const id = this.$route.params.id || '0'
    this.form.id = id === '0'? '' : id
    this.form.category = this.$route.path.indexOf('edit-article')>-1? 'ARTICLE':'BUG'
    // 如果是新增
    if(this.isAdd) {
      // 如果是新增bug，则写入模板内容
      if(!this.isArticle) {
        this.form.content = BUG_TEMPLATE
      }
    } else {
      // 获取文章详情
      this.getDetail()
    }
    this.getDraft()
  },
  // 离开页面提示
  beforeRouteLeave(to,from,next) {
    if(this.leaveActive) {
      next()
    }else {
      this.$confirm({
        title: '提示',
        content: '您有未发布的内容，确认是否离开？',
        onOk: ()=> {
          next()
        },
        onCancel() {
          next(from.fullPath)
        },
      })
    }
  },
  methods: {
    // 发布 type  PUBLISH-发布，DRAFT-草稿
    onSubmit(type) {
      // 未登录，跳转登录页
      if(!this.isLogin) {
        window.location.href = `/auth/login?fromUrl=https%3A%2F%2F${window.location.host}%2Fporos-community%2Findex`
        return
      }
      const validateImg = this.$refs.imgUpload.validate()
      const validateFile = this.$refs.fileUpload.validate()
      if(validateImg && validateFile) {
        this.$refs.form.validate().then(() => {
          const data = cloneDeep(this.form)
          data.postsStatus = type
          data.tagIds = data.tagIds.map(v=> v.id)
          // 如果是保存草稿，则置空id
          if(type==='DRAFT') data.id = ''
          // 标题encode
          data.title = encodeURI(data.title)
          // 防止xss攻击
          data.content = xss(data.content)
          saveArticle(data).then(res => {
            if(res.code === 0) {
              // 如果是草稿，更新草稿列表；如果是发布，则跳转详情页
              if(type==='DRAFT') {
                this.$message.success(`草稿保存成功！`)
                this.getDraft()
              } else {
                const cate = this.form.category.toLowerCase()
                const msg = cate === 'bug' ? '发布成功':'发布成功，待管理员审核'
                this.$message.success(msg)
                this.leaveActive = true
                setTimeout(() => {
                  this.$router.push(`/${cate}-detail/${res.data}`)
                }, 1000)
              }
            } else if(res.code === 401) {
              this.code401()
            }
          })
        }).catch(err => {
          this.$message.error('校验不通过，请检查表单项')
          console.log('校验不通过！', err)
        })
      }
    },
    // 获取编辑文章的详情
    getDetail() {
      getDetail(this.form.id).then(res => {
        if(res.code === 0) {
          this.updateContent(res.data)
        } else if(res.code === 401) {
          this.code401()
        }
      })
    },
    // 使用草稿内容替换当前内容
    updateContent(item) {
      this.form.title = decodeURI(item.title || '')
      this.form.content = item.content || ''
      this.form.contact = item.contact || ''
      this.form.department = item.department || ''
      this.form.tagIds = item.tagList || []
      this.form.imgList = item.imgList || []
      this.form.appendixList = item.appendixList || []
      // 手动更新富文本内容
      this.$refs.editor.updateContent(this.form.content)
      this.$forceUpdate()
    },
    // 获取草稿列表
    getDraft() {
      getDraftList(this.form.category).then(res=> {
        if(res.code===0) {
          this.draftList = res.data
        } else if(res.code === 401) {
          this.code401()
        }
      })
    },
    // 删除草稿
    delDraft(index) {
      delDraft(this.draftList[index].id).then(res=> {
        if(res.code===0) {
          this.draftList.splice(index, 1)
          // 更新草稿
          this.getDraft()
        } else if(res.code === 401) {
          this.code401()
        }
      })
    },
    // 接口401的反馈
    code401() {
      this.$message.error('您还未登录，或登录状态已失效')
      setTimeout(() => {
        logoutApi()
      }, 1000)
    },
     // 标签变化
    tagsUpdate(tags) {
      this.form.tagIds = [...tags]
      this.$refs.form.validateField('tagIds')
    },
    // 移除tag
    removeTag(removedTag) {
      this.form.tagIds = this.form.tagIds.filter(tag => tag.id !== removedTag.id)
      this.$refs.form.validateField('tagIds')
    },
  }
}
</script>
<style lang="less" scoped>
.edit-article {
  height: 100%;
  overflow-y: auto;
  .center-block {
    margin: 10px auto;
    padding: 30px 60px 80px 20px;
    border: 1px solid #e5e6e9;
    background-color: #fff;
  }
  /deep/.custom-form-item .ant-form-item-children {
    display: block;
    line-height: 1;
  }
  .head-img-body{
    position: relative;
    img {
      width: 100px;
      height: 75px;
      object-fit: cover;
    }
  }
  .head-img-del {
    position: absolute;
    right: 5px;top: 5px;
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    background: rgba(255, 255, 255, .8);
    color: #333;
    &:hover {
      background-color: #fff;
    }
  }
  .control-btns {
    display: flex;
    align-items: center;
    margin-top: 40px;
    .ant-btn{
      width: 80px;
    }
  }
  .draft-box {
    display: inline-flex;
    align-items: center;
    margin: 0 10px;
    font-size: 12px;
    line-height: 18px;
    color: rgba(4,12,44,0.85);
    cursor: pointer;

    .anticon {
      margin-right: 6px;
      font-size: 12px;
      color: rgba(4,12,44,0.65);
    }
  }
  .tip-text {
    margin-top: 5px;
    font-size: 12px;
    color: rgba(4,12,44,0.65);
    line-height: 18px;
    font-weight: 400;
    .anticon {
      color: rgba(4,12,44,0.65);
      margin-right: 5px;
    }
  }
}
</style>